import React from "react";
import useUpcommingTable from "./useUpcommingTable";
import Table from "../../Common/Table";
import icons from "../../../assets/images/constantIcons";
import { Link } from "react-router-dom";

const UpcommingsBooking = () => {
  const { columns, data } = useUpcommingTable(); // Get columns and data from the hook

  return (
    <>
      <div className="flex justify-between items-start mb-2 md:mb-0">
        <h1 className="text-heading text-lg xl:text-xl font-semibold mb-3 lg:mb-2">
          Upcoming booking
        </h1>
        <Link to="/mainDashboard/booking">
        <button className="cta !text-green font-bold rounded-full flex items-center mb-2">
        <p className="text-xs">View All</p>
          <icons.FaArrowRightLong className="ml-2" />
        </button>
        </Link>
      </div>
      <div className="overflow-auto horizontalscroll h-[400px] vertical">
        <Table columns={columns} data={data} />
      </div>
    </>
  );
};

export default UpcommingsBooking;
